<template>
     <el-container class="pagination-list timing-task">
      <el-main>
        <div class="content">
          <el-form :inline="true" @submit.native.prevent>
            <el-form-item>
              <div class="operation">
                <el-input  prefix-icon="el-icon-search" v-model="conditions.keyword" placeholder="请输入名称/创建人" @keyup.enter.native="search" clearable/>
                <el-button class="search-button" @click="search">查询</el-button>
              </div>
            </el-form-item>
            <el-form-item class="operation-buttons">
              <el-dropdown trigger="click" class="timing-task-dropdown" @command="type => addRow(type)">
                <el-button type="primary">
                  添加 <span class="button-line">&nbsp;</span><i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="process">定时发起流程</el-dropdown-item>
                  <el-dropdown-item command="data">定时业务操作</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-form-item>
          </el-form >
            <div class="table-list">
              <el-table class="table-list" :data="items" v-loading="loading" height='100%' width="100%" empty-text="暂无定时操作，请点击添加">
                <template  v-for="(col,index) in cols" >
                  <el-table-column :key="index"
                  :formatter="formatter"
                  :prop="col.prop" :label="col.label" align="center" show-overflow-tooltip>
                  </el-table-column>
                </template>
                  <el-table-column
                  fixed="right" label="操作" align="center">
                    <template slot-scope="scope">
                      <el-button type="text" @click="editRow(scope.row)">编辑</el-button>
                      <el-button class="del-row" type="text" @click="delRow(scope.row)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-footer height="32px" class="pagination-footer">
                  <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pagination.currentPage"
                    :page-sizes="pagination.pageSizes"
                    :page-size="pagination.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="pagination.total">
                  </el-pagination>
                </el-footer>
           </div>
        </div>
    </el-main>
    <el-dialog
      class="timing-task-dialog"
      :title="timingDialog.title"
      v-if="timingDialog.visiable"
      :visible.sync="timingDialog.visiable"
      width="540px"
      center
      :close-on-click-modal="false">
      <div>
        <el-form ref="form" class="timing-design" label-position="left" :inline="true" :model="timingForm">
          <div class="title">名称</div>
           <el-form-item label="" prop="jobName" :rules=" {required: true, message: '请输入名称', trigger: 'blur'}">
            <el-input class="name" v-model="timingForm.jobName" placeholder="请输入" clearable/>
           </el-form-item>
           <div class="title">开始时间</div>
            <el-form-item label="" class="mr22" prop="startDate" :rules="{required: true, message: '请选择日期', trigger: 'change'}">
             <el-date-picker class="w227"
              v-model="timingForm.startDate"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
           </el-form-item>
           <el-form-item label="" class="mr22" prop="hour" :rules="{required: true, message: '请选择时', trigger: 'change'}">
              <el-select class="w85" v-model="timingForm.hour" placeholder="请选择" filterable>
                <el-option
                  v-for="item in hours"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              时
           </el-form-item>
            <el-form-item label="" prop="second" :rules="{required: true, message: '请选择分', trigger: 'change'}">
              <el-select class="w85" v-model="timingForm.second" placeholder="请选择" filterable>
                <el-option
                  v-for="item in seconds"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              分
           </el-form-item>
            <el-form-item class="mr22" label="周期" prop="cycle" :rules="{required: true, message: '请选择周期', trigger: 'change'}">
              <el-select class="w188" v-model="timingForm.cycle" placeholder="请选择" @change="changeCycle">
                <el-option
                  v-for="item in cycles"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
           </el-form-item>
           <el-form-item label="每隔" v-if="timingForm.cycle&&timingForm.cycle!=='onetime'" prop="timeInterval" :rules="{validator: validateLimit, options:timingForm, trigger: 'blur'}">
              <el-input class="w89"  v-model="timingForm.timeInterval" clearable/>
              {{field}}
           </el-form-item>
           <div class="line"></div>
           <template v-if="timingDialog.type === 'data'">
             <div class="content">
               <div class="title">数据归档</div>
               <el-form-item label="数据源" label-width="58px" prop="reportId" :rules="{required: true, message: '请选择数据源', trigger: 'change'}">
                 <public-combobox
                   ref="reportpublicCombobox"
                   class="w178"
                   v-model="timingForm.reportId"
                   :options="timingDialog.dataSourceReports"
                   @change="datasourceChange($event)"
                   :showOperationLength="10"
                   :placeholder="'请选择数据源'">
                 </public-combobox>
               </el-form-item>
               <el-form-item label="目标表" label-width="58px"  prop="tableId" :rules="{required: true, message: '请选择目标表', trigger: 'change'}">
                 <public-combobox
                   ref="tablepublicCombobox"
                   class="w178"
                   v-model="timingForm.tableId"
                   :options="timingDialog.tables"
                   @change="targetTableChange($event)"
                   :showOperationLength="10"
                   :placeholder="'请选择目标表'">
                 </public-combobox>
               </el-form-item>
               <div class="title">归档字段</div>
               <div class="quartz-data-mapping-list">
                 <div class="flex" v-for="(el,i) in timingForm.quartzDataMappingList" :key="i">
                   <el-form-item :prop="'quartzDataMappingList.'+i+'.sourceId'" :rules="{required: true, message: '请选择源表字段', trigger: 'change'}">
                     <public-combobox
                       class="dataSource-columns"
                       v-model="el.sourceId"
                       :options="timingDialog.dataSourceColumns"
                       :placeholder="'请选择源表字段'">
                     </public-combobox>
                   </el-form-item>
                   <el-form-item :prop="'quartzDataMappingList.'+i+'.targetId'" :rules="{required: true, message: '请选择目标表字段', trigger: 'change'}">
                     <public-combobox
                       class="table-columns"
                       v-model="el.targetId"
                       :options="timingDialog.tableColumns"
                       :placeholder="'请选择目标表字段'">
                     </public-combobox>
                   </el-form-item>
                   <i class="el-icon-delete del-Field" @click="delField(i)"></i>
                 </div>

               </div>
             </div>
             <i class="el-icon-plus add-field" @click="addField()">添加归档字段</i>
             <el-form-item label="备注">
               <el-input class="comment" type="text" v-model="timingForm.comment" clearable/>
             </el-form-item>
           </template>
          <template v-else>
            <div class="content">
              <div class="title">定时发起流程</div>
              <el-form-item prop="processDefineId" :rules="{required: true, message: '请选择流程', trigger: 'change'}">
                <el-select class="w488" v-model="timingForm.processDefineId" placeholder="请选择流程" @change="changeProcess" filterable>
                  <el-option
                    v-for="item in process"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="inform-scope" label="通知范围" prop="candidate" :rules="{required: true, message: '请选择通知范围'}">
                <div class="inform-scope-content">
                  <div class="left"><i class="el-icon-plus" @click="openDialog"></i></div>
                  <div class="right">
                    <span class="candidate-item" :title="item.name" v-for="(item, index) in timingForm.candidate" :key="item.id">{{ item.name }}{{ getComma(index) }}</span>
                  </div>
                </div>
              </el-form-item>
              <el-form-item class="inform-type" label="通知类型" prop="informType" :rules="{required: true, message: '请选择通知类型'}">
                <el-checkbox-group v-model="timingForm.informType">
                  <el-checkbox label="email">邮件</el-checkbox>
                  <el-checkbox label="app">APP</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <div class="inform-content">
                <el-form-item label="通知内容" prop="content" :rules="{required: true, message: '请输入通知内容'}">
                  <el-input class="w488" resize="none" type="textarea" :rows="3" placeholder="请输入通知内容" v-model="timingForm.content"></el-input>
                </el-form-item>
              </div>
            </div>
          </template>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="timing-button-primary" type="primary" @click="saveTimingForm">保 存</el-button>
        <el-button class="timing-button-default" @click="timingDialog.visiable = false">取 消</el-button>
      </span>
    </el-dialog>
       <select-inform-people v-if="selectInformDialog.visable" :data="selectInformDialog" @getCandidate="getCandidate"></select-inform-people>
  </el-container>
</template>

<script>
import moment from 'moment'
import { UUID } from '@/plugins/common'
import publicCombobox from '@/components/public/public-combobox.vue'
import SelectInformPeople from './select-inform-people'
export default {
  name: 'TimingTask',
  data () {
    let hours = []
    let seconds = []
    for (let i = 0; i < 24; i++) {
      i = i < 10 ? '0' + i : i
      hours.push({'value': i, 'label': i})
    }
    for (let i = 0; i < 60; i++) {
      i = i < 10 ? '0' + i : i
      seconds.push({'value': i, 'label': i})
    }
    return {
      timingDialog: {
        visiable: false,
        id: '',
        title: '添加定时操作',
        tables: [],
        tableColumns: [],
        dataSourceReports: [],
        dataSourceColumns: [],
        type: 'process'
      },
      timingForm: {
        id: '',
        jobName: '',
        jobId: '',
        hour: '',
        second: '',
        cycle: '',
        startDate: '',
        startTime: '',
        timeInterval: null,
        reportId: '',
        tableId: '',
        quartzDataMappingList: [{sourceId: '', targetId: ''}],
        comment: '',
        jobStatus: '',
        // 定时发起流程
        processDefineId: '',
        // 通知范围
        candidate: [],
        // 通知类型
        informType: [],
        // 通知内容
        content: '',
        quartzProcessDesignId: ''
      },
      hours,
      seconds,
      cycles: [
        {value: 'day', label: '每天'},
        {value: 'month', label: '每月'},
        {value: 'hour', label: '每时'},
        {value: 'min', label: '每分'},
        {value: 'sec', label: '每秒'},
        {value: 'week', label: '每周'},
        {value: 'year', label: '每年'},
        {value: 'onetime', label: '一次'}
      ],
      conditions: { keyword: '' },
      pagination: {currentPage: 1, pageSize: 20, pageSizes: [10, 20, 30, 50, 100], total: 0},
      loading: false,
      items: [],
      cols: [
        {prop: 'jobName', label: '名称'},
        {prop: 'way', label: '执行方式'},
        {prop: 'jobType', label: '定时类型'},
        {prop: 'createTime', label: '创建时间'},
        {prop: 'createUser', label: '创建人'},
        {prop: 'comment', label: '备注'}
      ],
      filters: {},
      process: [],
      selectInformDialog: {
        visable: false,
        data: []
      }
    }
  },
  components: {publicCombobox, SelectInformPeople},
  created () {
    this.loadTables()
    this.loadDataReports()
    this.getTableData()
    this.getProcess()
  },
  computed: {
    field () {
      let field = ''
      switch (this.timingForm.cycle) {
        case 'day':
          field = '天'
          break
        case 'month':
          field = '月'
          break
        case 'hour':
          field = '时'
          break
        case 'min':
          field = '分'
          break
        case 'sec':
          field = '秒'
          break
        case 'week':
          field = '周'
          break
        case 'year':
          field = '年'
          break
        case 'onetime':
          field = ''
          break
      }
      return field
    },
    // 去除前缀，不知道后期是否需要加上 先注释
    // getCandidateName () {
    //   return item => `已选${item.type === 'user' ? '人员' : item.type === 'group' ? '群组' : '部门'}${item.name}`
    // },
    getComma () {
      return index => this.timingForm.candidate.length - 1 !== index ? '，' : ''
    }
  },
  methods: {
    validateLimit  (rule, value, callback) {
      let m = rule.options
      if (m.cycle === 'sec') {
        if (isNaN(Number(value)) || Number(value) < 10) {
          callback(new Error('不得少于10秒'))
        }
      } else {
        if (isNaN(Number(value)) || Number(value) < 1) {
          callback(new Error('必须大于0的整数'))
        }
      }
      callback()
    },
    loadTables () {
      this.$axios.get('/report-api/report/definition/tables')
        .then(res => {
          if (res.data) {
            this.timingDialog.tables = res.data
          }
        })
    },
    loadDataReports () {
      this.$axios.get(`/report-api/report/definition/dataSourceReports`).then((res) => {
        this.timingDialog.dataSourceReports = res.data
      })
    },
    formatter (row, column) {
      let data = row[column.property]
      if (column.property === 'way') {
        let field = `每隔${row.timeInterval}`
        switch (row.cycle) {
          case 'day':
            field = `${field}天`
            break
          case 'month':
            field = `${field}月`
            break
          case 'hour':
            field = `${field}小时`
            break
          case 'min':
            field = `${field}分`
            break
          case 'sec':
            field = `${field}秒`
            break
          case 'week':
            field = `${field}周`
            break
          case 'year':
            field = `${field}年`
            break
          case 'onetime':
            field = '只一次'
            break
        }
        return `从${row.startTime}开始${field}执行此动作`
      } else if (column.property === 'jobType') {
        return data === 'process' ? '定时发起流程' : '定时业务操作'
      }
      return data
    },
    addRow (type) {
      this.timingDialog.type = type
      this.timingDialog.visiable = true
      this.timingForm = {
        id: UUID.create(),
        jobName: '',
        hour: '',
        second: '',
        cycle: '',
        startDate: '',
        startTime: '',
        timeInterval: null,
        reportId: '',
        tableId: '',
        quartzDataMappingList: [{sourceId: '', targetId: ''}],
        comment: '',
        // 定时发起流程
        processDefineId: '',
        // 通知范围
        candidate: [],
        // 通知类型
        informType: [],
        // 通知内容
        content: ''
      }
      this.timingDialog.title = '添加定时操作'
    },
    editRow (row) {
      this.timingDialog.visiable = true
      this.timingDialog.title = '编辑定时操作'

      this.$axios.get(`/task-api/job/${row.jobId}`).then((res) => {
        this.timingForm.id = res.data.id
        this.timingForm.jobName = res.data.jobName
        this.timingForm.cycle = res.data.cycle
        this.timingForm.startTime = res.data.startTime
        this.timingForm.timeInterval = res.data.timeInterval
        this.timingForm.reportId = res.data.reportId
        this.timingForm.tableId = res.data.tableId
        this.timingForm.quartzDataMappingList = res.data.quartzDataMappingList
        this.timingForm.comment = res.data.comment
        this.timingForm.jobId = res.data.jobId
        this.timingForm.jobStatus = res.data.jobStatus
        let splitTime = res.data.startTime.split(' ')
        this.timingForm.startDate = splitTime[0]
        this.timingForm.hour = splitTime[1].split(':')[0]
        this.timingForm.second = splitTime[1].split(':')[1]
        if (res.data.jobType === 'process') {
          // 定时发起流程
          this.timingForm.processDefineId = res.data.quartzProcessDesign.processDefineId
          // 通知范围
          this.timingForm.candidate = res.data.quartzProcessDesign.candidate
          // 通知类型
          this.timingForm.informType = res.data.quartzProcessDesign.informType.split(',')
          // 通知内容
          this.timingForm.content = res.data.quartzProcessDesign.content
          this.timingForm.quartzProcessDesignId = res.data.quartzProcessDesign.id
        }
        this.timingDialog.type = res.data.jobType
        this.$nextTick(() => this.$refs.reportpublicCombobox && this.$refs.reportpublicCombobox.setOptions(res.data.reportId))
        this.$nextTick(() => this.$refs.tablepublicCombobox && this.$refs.tablepublicCombobox.setOptions(res.data.tableId))
        this.targetTableChange(res.data.tableId, 'edit')
        this.datasourceChange(res.data.reportId, 'edit')
      })
    },

    delRow (row) {
      let jobId = row.jobId
      this.$confirm('', '你确认删除吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'deleMessageBox',
        center: true
      })
        .then(() => this.$axios.delete('/task-api/job/' + jobId))
        .then(res => {
          this.getTableData()
        })
    },
    search () {
      // 页数为 1
      this.pagination.currentPage = 1
      this.initParams()
    },
    initParams () {
      this.filters = {
        'keyword': this.conditions.keyword
      }
      this.getTableData()
    },
    // 调用接口获取tableData数据
    getTableData () {
      this.loading = true
      let page = this.pagination
      let params = {
        'index': page.currentPage,
        'size': page.pageSize
      }
      params.filters = this.filters

      this.$axios.get('/task-api/job/list', {params})
        .then((res) => {
          // 页面数据改变重新统计数据数量和当前页
          this.pagination.total = res.data.total
          if (this.pagination.total && (this.pagination.currentPage - 1) * this.pagination.pageSize >= this.pagination.total) {
            this.pagination.currentPage--
            return
          }
          this.items = res.data.items
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
    },
    handleSizeChange (val) {
      this.pagination.pageSize = val
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.pagination.currentPage = val
      this.getTableData()
    },
    addField () {
      this.timingForm.quartzDataMappingList.push({id: UUID.create(), sourceId: '', targetId: ''})
    },
    delField (index) {
      this.timingForm.quartzDataMappingList.splice(index, 1)
    },
    targetTableChange (value, type) {
      if (!type) {
        this.timingForm.quartzDataMappingList = [{id: UUID.create(), sourceId: '', targetId: ''}]
      }
      if (value) {
        this.loadTable(value).then((columns) => {
          this.timingDialog.tableColumns = columns
        })
      }
    },
    datasourceChange (value, type) {
      if (!type) {
        this.timingForm.quartzDataMappingList = [{id: UUID.create(), sourceId: '', targetId: ''}]
      }
      if (value) {
        this.loadDataReport(value).then((columns) => {
          this.timingDialog.dataSourceColumns = columns
        })
      }
    },
    changeCycle (val) {
      this.timingForm.cycle = val
      this.timingForm.timeInterval = ''
      this.$nextTick(() => this.$refs.form.clearValidate(['timeInterval']))
    },
    changeProcess (val) {
      let item = this.process.find(c => c.id === val)
      if (item) {
        this.timingForm.content = `您有一个${item.name}流程需要及时处理`
      }
    },
    loadTable (tableId) {
      return new Promise((resolve, reject) => {
        let table = this.timingDialog.tables.find(m => m.id === tableId)
        if (table && !table.columns) {
          this.$axios.get(`/data-api/table/${tableId}`)
            .then(res => {
              this.$set(table, 'columns', res.data.columns)
              // 因为上面的 table 是克隆出来的的, 对其进行修改不会改变 options 里面的东西, 所以在这里重新查询一下
              resolve(res.data.columns)
            })
        } else {
          resolve(table.columns)
        }
      })
    },
    loadDataReport (reportId) {
      return new Promise((resolve, reject) => {
        let dataSourceReport = this.timingDialog.dataSourceReports.find(m => m.id === reportId)
        if (!dataSourceReport.columns || !dataSourceReport.columns.length) {
          this.$axios.get(`/report-api/report/definition/${reportId}?type=run`)
            .then(res => {
              this.$set(dataSourceReport, 'columns', res.data.columns)
              resolve(res.data.columns)
            })
        } else {
          resolve(dataSourceReport.columns)
        }
      })
    },
    getProcess () {
      // 获取所有流程
      this.$axios.get('/process-api/processes/findAll').then(res => {
        this.process = res.data || []
      })
    },
    saveTimingForm () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let process = this.process.find(c => c.id === this.timingForm.processDefineId)
          this.timingForm.startTime = moment(this.timingForm.startDate).format('YYYY-MM-DD') + ' ' + this.timingForm.hour + ':' + this.timingForm.second + ':00'
          let JobDesign = {
            id: this.timingForm.id,
            jobName: this.timingForm.jobName,
            cycle: this.timingForm.cycle,
            startTime: this.timingForm.startTime,
            timeInterval: this.timingForm.timeInterval,
            reportId: this.timingForm.reportId,
            tableId: this.timingForm.tableId,
            quartzDataMappingList: this.timingForm.quartzDataMappingList,
            comment: this.timingForm.comment,
            jobId: this.timingForm.jobId,
            jobStatus: this.timingForm.jobStatus,
            jobType: this.timingDialog.type
          }
          if (this.timingDialog.type === 'process') {
            JobDesign.quartzProcessDesign = {
              // 定时发起流程
              processDefineId: this.timingForm.processDefineId,
              // 通知范围
              candidate: this.timingForm.candidate,
              // 通知类型
              informType: this.timingForm.informType.join(','),
              // 通知内容
              content: this.timingForm.content,
              id: this.timingForm.quartzProcessDesignId ? this.timingForm.quartzProcessDesignId : UUID.create(),
              processName: process.name
            }
          }
          this.$axios.post('/task-api/job/saveJob', JobDesign).then(() => {
            this.timingDialog.visiable = false
            this.getTableData()
          })
        }
      })
    },
    openDialog () {
      this.selectInformDialog.visable = true
      this.selectInformDialog.data = this.timingForm.candidate
    },
    getCandidate (data) {
      this.timingForm.candidate = data
      this.selectInformDialog.visable = false
      this.$refs.form.validateField('candidate')
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/common.scss';
.timing-task {
  .el-main {
    >.content .operation .el-input {
      width: 384px;
    }

    .operation-buttons {
      .timing-task-dropdown {
        .el-button {
          padding: 5px 10px;
          .button-line {
            position: relative;
            &:before {
              content: '';
              width: 1px;
              height: 13px;
              background-color: #fff;
              display: inline-block;
              position: absolute;
              left: 4px;
              top: 2px;
            }
          }
        }
      }
    }

    .table-list {
      .el-table__fixed-right {
       box-shadow: none;
       .el-table__fixed-header-wrapper{
        tr th:nth-last-of-type(1){
          border-right: none;
        }
       }
      }
      .del-row {
        color:  #A5A5A5;

        &:hover {
          color: #FB9391;
        }

        &:active {
          color: #FB9391;
        }
      }
    }
  }
}

.timing-task-dialog {
  .el-dialog--center .el-dialog__body {
    font-size: 12px;
    padding: 18px 8px 14px 16px;
    color: #2C2C2C;

    .timing-design {
      .title {
        font-size: 12px;
        color: #2C2C2C;
        margin-bottom: 12px;
      }

      .add-field {
        color: #2C2C2C;
        text-align: center;
        display: block;
        height: 20px;
        line-height: 20px;
        font-size: 12px;
        cursor: pointer;

        &:hover {
          color: #409EFF;
        }

        &:active {
          color: #388DD2
        }
      }

      .flex {

        .dataSource-columns {
          width: 234px;

          .el-select {
            width: 100%;
          }
        }

        .table-columns {
          width: 234px;

          .el-select {
            width: 100%;
          }
        }

        &:hover {
          .del-Field {
            visibility: visible;
          }
        }

        .del-Field {
          color: #BDCCD9;
          visibility: hidden;
          cursor: pointer;
          margin-left: 2px;
          margin-top: 7px;

          &:hover {
            color: #FB9391;
          }

          &:active {
            color: #F33648;
          }
        }
      }

      .el-form-item {
        margin-bottom: 14px;
        .el-form-item__label {
          font-size: 12px;
          color: #2C2C2C;
          &::before {
            display: none;
          }
        }

        &.mr22 {
          margin-right: 22px;
        }
      }

      .name,
      .comment {
        width: 488px;
      }
      .w89 {
        width: 89px;
      }

      .w227 {
        width: 227px;
      }

      .w178 {
        width: 178px;
      }

      .w85 {
        width: 85px;
      }

      .w188 {
        width: 188px;
      }

      .line {
        width: 100%;
        height: 1px;
        background: #DBDBDB;
      }

      .w488 {
        width: 488px;
      }

      .content {
        padding-top: 20px;

        .quartz-data-mapping-list {
          max-height: 150px;
          overflow-y: auto;
          .el-form-item:nth-child(2n) {
            margin-right: 2px;
          }
          .el-input {
            width: 240px;
          }
        }

        .inform-scope {
          .el-form-item__content {
            .inform-scope-content {
              width: 440px;
              display: flex;
              justify-content: space-between;
              .left {
                width: 20px;
                .el-icon-plus {
                  color: #54ABF1;
                  cursor: pointer;
                  &:active {
                    color: #388DD2;
                  }
                }
              }
              .right {
                width: calc(100% - 37px);
                max-height: 112px;
                overflow-y: auto;
                line-height: 17px;
                padding-top: 6px;
                .candidate-item {
                  // 这个是去除前缀之前的宽度，先注释
                  /*width: 92px;*/
                  width: 74px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  font-size: 12px;
                  display: inline-block;
                  margin-right: 5px;
                }
              }
            }
            .el-form-item__error {
              left: 132px;
              top: calc(100% - 10px);
            }
          }
        }
        .inform-type {
          .el-form-item__content {
            .el-checkbox-group {
              .el-checkbox {
                .el-checkbox__input {
                  .el-checkbox__inner {
                    background-color: #fff;
                    border-color: #DCDFE6;
                    &::after {
                      border-color: #54ABF1;
                    }
                  }
                }
                .el-checkbox__label {
                  color: #2C2C2C;
                  font-size: 12px;
                }
                .is-checked {
                  .el-checkbox__inner {
                    border-color: #54ABF1;
                  }
                  .el-checkbox__label {
                    color: #2C2C2C;
                    font-size: 12px;
                  }
                }
              }
            }
            .el-form-item__error {
              top: calc(100% - 10px);
            }
          }
        }
      }
    }
    .job-status {
      margin-left: 16px;
    }
  }
}
.timing-task-dialog, .select-inform-people-dialog {
  .dialog-footer {
    .timing-button-default {
      padding: 0;
      width: 82px;
      height: 26px;
      line-height: 24px;
      background-color: #fff;
      border-color: #E5E8ED;
      margin-left: 50px;
      &:hover {
        border-color: #c6e2ff;
        background-color: #ecf5ff;
      }
      &:active {
        border-color: var(--shade-1, #3a8ee6);
      }
    }
    .timing-button-primary {
      padding: 0;
      width: 82px;
      height: 26px;
      line-height: 24px;
      background-color: var(--primary, #54ABF1);
      border-color: var(--primary, #54ABF1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/system/system/timing-task.vue